import request from '@/utils/request'

const http = request()

export const listHzProject = params => http.post('/project/hz/list', params)

export const viewPrj = (projectId, isDetail = false) => (isDetail ? http.post('/project/hz/detail', { projectId }) : http.post('/project/hz/view', { projectId }))

export const updatePrj = params => http.raw('/project/hz/update', params)

export const getHzBudgets = projectId => http.post('/project/hz/budgets', { projectId })

export const reviewPrj = params => http.post('/project/hz/review', params)

export const resetRaises = params => http.post('/project/hz/raises', params)

export const stopPrj = projectId => http.post('/project/hz/stop', { projectId })

export const concludePrj = projectId => http.post('/project/hz/conclude', { projectId })

export const closePrj = projectId => http.post('/project/hz/close', { projectId })

export const backwardPrj = projectId => http.post('/project/hz/backward', { projectId })

export const getRaise = raiseId => http.post(`/project/raise/${raiseId}`, { raiseId })

export const getRaises = projectId => http.post('/project/raise/list', { projectId })

export const applyRaise = params => http.raw('/project/raise/apply', params)

export const reviewRaise = params => http.post('/project/raise/review', params)

export const exportPrjs = params => http.blob('/project/hz/export', params)
